// @flow
import styled from 'styled-components';
import colors from "../../assets/css/colors";

export const SearchField = styled.input`
	background: #fff;
	height: 100%;
	width: 100%;
	font-size: 12px;
	line-height: 1.5;
	color: ${colors.darkGrey};
	outline: none;
	box-sizing: border-box;
	padding: 0 48px 0 12px;
	border: none;
`;

export default SearchField;


// WEBPACK FOOTER //
// ./src/components/SearchField/index.js